import styled from "@emotion/styled";

import { commonColors } from "application/theme";
import { ReactComponent as Logo } from "./assets/logo.svg";

export const Container = styled("div")`
  height: 100%;
  display: flex;
`;

export const LogoIcon = styled(Logo)`
  align-self: center;
  margin-bottom: 12px;
`;

export const Card = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 55px;
  padding: 32px 16px;
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  background: ${commonColors.white};
`;

export const Content = styled("div")`
  h1 {
    margin-bottom: 6px;
    /* font */
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
    margin-bottom: 4px;
    text-align: center;
    color: ${commonColors.grey900};
  }
  p {
    margin-bottom: 20px;
    /* font */
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0.08px;
    color: ${commonColors.grey900};
  }
`;

export const ButtonsSection = styled("div")`
  gap: 12px;
  display: flex;
  button {
    flex: 1;
  }
`;

export const LanguagesLabel = styled("label")`
  display: block;
  margin: 20px 0 12px 0;
  /* font */
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.08px;
  color: ${commonColors.grey900};
`;

export const LanguagesList = styled("div")`
  gap: 16px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const LoaderContainer = styled("div")`
  flex: 1;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
